module.exports = __webpack_public_path__ + "9889aa9973fddd5ef59027f04ab51caa.png";